// Configuración de EmailJS
export const emailConfig = {
  serviceId: 'service_oq8o29c',
  templateId: 'template_d6zlnwi',
  publicKey: 'A1dijvRHyVSKMpDtQ',
  toEmail: 'contacto@servibalanzas.cl',
  fromEmail: 'contacto@servibalanzas.cl'
};

export default emailConfig;
